import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from './styles.module.css';
import TableClients from "./libs/table-clients";

const ClientsWithoutWhatsapp = () => {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);

    return (
        <div className={s.container}>
            <div className={s.content}>
                <div className={s.title}>
                    <h1 className={s['title-text']}>
                        {t('clientsWithoutWhatsapp')}
                    </h1>
                </div>

                <TableClients
                    page={page}
                    onPageChange={setPage}
                />
            </div>
        </div>
    );
};

export default ClientsWithoutWhatsapp;
